module.exports = __webpack_public_path__ + "static/media/default-profile.e4833d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/default-profile.png
// module id = 797
// module chunks = 0